import 'react-app-polyfill/ie9';
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './components/App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import './styles/app.scss';
//import * as serviceWorker from './serviceWorker';

// import { polyfillLoader } from 'polyfill-io-feature-detection';
// // This function load polyfills only if needed. By default it uses polyfill.io
// polyfillLoader({
//     'features': 'Promise,fetch',
//     'onCompleted': main
// });

(function (w) {

    w.URLSearchParams = w.URLSearchParams || function (searchString) {
        var self = this;
        self.searchString = searchString;
        self.get = function (name) {
            var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(self.searchString);
            if (results == null) {
                return null;
            }
            else {
                return decodeURI(results[1]) || 0;
            }
        };
    };

})(window);

//serviceWorker.register();

ReactDOM.render(<App />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/indexApp.js